<template>
  <v-bottom-sheet v-model="bottomPickerFlag">
    <v-sheet class="bottom-sheet-wrap">
      <!-- 시 -->
      <v-row class="ma-0" height="283px">
        <v-col cols="6" class="pa-0">
          <p class="pl-6 mb-0 font-weight-bold">시</p>
          <div class="time-gradation top"></div>
          <div>
            <v-container
              style="max-height: 208px"
              class="ma-0 pa-0 scroll-always"
            >
              <div class="text-left" v-scroll.self="onScroll">
                <v-list>
                  <v-list-item-group v-model="selectedTime.hourIdx">
                    <v-list-item
                      v-for="(hour, i) in hourList"
                      :key="i"
                      @click="selectItem(hour, 'H')"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="hour" />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-container>
          </div>
          <div class="time-gradation bottom"></div>
        </v-col>

        <!-- 분 -->
        <v-col cols="6" class="pa-0">
          <p class="pl-6 mb-0 font-weight-bold">분</p>
          <div class="time-gradation top"></div>
          <v-container
            class="ma-0 pa-0 scroll-always"
            style="max-height: 208px"
          >
            <div class="text-left" v-scroll.self="onScroll">
              <v-list>
                <v-list-item-group v-model="selectedTime.minIdx">
                  <v-list-item
                    v-for="(minute, i) in minuteList"
                    :key="i"
                    @click="selectItem(minute, 'M')"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="minute" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-container>
          <div class="time-gradation bottom"></div>
        </v-col>
      </v-row>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
/* 시간선택 컴포넌트 */
import { getTimePickerList } from '@/utils/common/timeUtil';

export default {
  props: {
    flag: {
      type: Boolean,
    },
    /* 현재시간 */
    currTime: {
      type: Object,
      // default() {
      //   return { hour: '00', min: '00' }; // 없을 경우 기본시간 세팅
      // },
    },
  },

  data: () => ({
    bottomPickerFlag: false, // 화면플래그
    hourList: [],
    minuteList: [],

    selectedTime: {},
    hour: '', // 시
    minute: '', // 분
    time: '', // 시간
  }),

  watch: {
    flag() {
      this.bottomPickerFlag = !this.bottomPickerFlag;
    },

    currTime() {
      this.hour = this.currTime.hour;
      this.minute = this.currTime.min;

      // 현재 기본 세팅된(전달된) 시간이 있을 경우 선택처리
      if (this.hour !== '' && this.minute !== '') {
        this.hourList.forEach((data, i) => {
          if (this.hour === data) this.selectedTime['hourIdx'] = i;
        });

        this.minuteList.forEach((data, i) => {
          if (this.minute === data) this.selectedTime['minIdx'] = i;
        });
      }
    },

    time() {
      if (this.time.length >= 5) {
        this.$emit('changeTime', this.time);
        this.bottomPickerFlag = false;
      }
    },
  },

  methods: {
    onScroll() {},

    /* 시간선택 */
    selectItem(time, type) {
      if (type === 'H') {
        this.hour = time;
      } else {
        this.minute = time;
      }

      if (this.hour !== '' && this.minute !== '') {
        this.time = `${this.hour}:${this.minute}`;
      }
    },
  },

  created() {
    this.hourList = getTimePickerList('H');
    this.minuteList = getTimePickerList('M');
  },
};
</script>

<style scoped>
.picker-group {
  display: flex;
}

/* bottom-sheet */
.bottom-sheet-wrap {
  border-radius: 20px 20px 0 0;
}
.sheet-title {
  padding: 30px 24px 20px;
  font-weight: bold;
  line-height: 1.5;
  color: #363c43;
}

/* 길이 변경 */
::-webkit-scrollbar {
  width: 4px;
}

/* 트랙 (Track) */
::-webkit-scrollbar-track {
}

/* 핸들 (Handle) */
::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 3px;
}

/* bottomTimePicker.scss 참고 */
</style>
